import request from '@/utils/request'
import airDropRequest from '@/utils/airDropRequest'
import { getContractAbiRequest } from '@/utils/contract-abis'

// download file
export const getFile = (data) => {
  return request({
    url: '/api/file/getFile',
    method: 'get',
    params: data,
    responseType: 'blob',
    vconfig: {
      noErr: true,
      responseType: 'blob'
    }
  })
}

export const getAbi = (name) => {
  const abiRequest = getContractAbiRequest(name)
  return airDropRequest({
    url: abiRequest.url,
    method: 'get',
    params: abiRequest.params
  })
}

export const availableList = () => {
  return request({
    url: `/api/dapps/availableList`,
    method: 'get'
  })
}
